import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import BlogList from "./sections/BlogList";
import EduFutureKnowledgeBase from "./sections/EduFutureKnowledgeBase";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <BlogList /> 
      <Footer />
    </div>;
}